import { Injectable } from "@angular/core";
import { CanLoad, Router, Route, UrlTree, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppState, selectAuthState } from "src/app/store/app.states";
import { StorageService } from "../common/storage";


@Injectable(
    {
        providedIn: 'root'
    }
)
export class AuthGuardService implements CanLoad, CanActivate {
    constructor(private localStorage: StorageService, private store: Store<AppState>,
        private router: Router) {
    }

    canActivate(): Observable<boolean> | boolean {
        return this.canLoad(undefined);
    }
    canLoad(route: Route): Observable<boolean> | boolean {
        return new Observable(observer => {

            this.store.select(selectAuthState).subscribe((state) => {
                if(state.isAuthenticated){
                    observer.next(true);

                }
                else {
                    observer.next(false);
                    this.router.navigate(["/login"]);
                }
               
            });
        });

    }
}